module.exports = __webpack_public_path__ + "static/media/icon-event-link.d4add420.svg";